const FilterIcon = ({ fill = "#374151" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    style={{ margin: 0 }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10275_207589)">
      <path
        d="M5.24855 4H4.21467L4.8566 4.81045L8.5991 9.53545L8.99026 10.0293L9.38239 9.53621L13.1399 4.81121L13.785 4H12.7485H5.24855ZM7.49855 9.75L7.89332 9.44316L7.89323 9.44304L7.89284 9.44254L7.89132 9.44058L7.88528 9.43281L7.86156 9.40228L7.77017 9.28469L7.43253 8.85029L6.30511 7.40024C5.4167 6.25786 4.33887 4.87261 3.58118 3.90111C3.45432 3.7359 3.57027 3.5 3.77855 3.5H14.211C14.4193 3.5 14.5353 3.73587 14.4084 3.90108C13.6506 4.87279 12.5745 6.25824 11.6879 7.40064C11.2444 7.97212 10.8483 8.48287 10.563 8.85076L10.2262 9.28519L10.1351 9.40279L10.1114 9.43332L10.1054 9.44109L10.1039 9.44306L10.1035 9.44355L10.1034 9.44367L10.4985 9.75L10.1033 9.44371L9.99855 9.57893V9.75V14.25C9.99855 14.3864 9.8849 14.5 9.74855 14.5H8.24855C8.11219 14.5 7.99855 14.3864 7.99855 14.25V9.75V9.57857L7.89336 9.4432L7.49855 9.75Z"
        fill={fill}
        stroke={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_10275_207589">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FilterIcon;
